const agent = (state = { isMobile: false, device: "" }, action) => {
  switch (action.type) {
    case "MOBILE":
      return { isMobile: true, device: "mobile" };
    case "TABLET":
      return { isMobile: true, device: "tablet" };
    case "PC":
      return { isMobile: false, device: "pc" };
    default:
      return state;
  }
};

export default agent;
